import { serializeUrl } from '../internal/serialize-url'
import { ClassroomParams, classroomUrlParamsSchema } from '../schemas/classroom-params'

export const buildClassroomUrl = (params: ClassroomParams): string => {
  const { classId, level, week, permission, langType, sessionId, referrer, originals } =
    classroomUrlParamsSchema.parse(params)

  const query: Record<string, string | number> = {}

  // eslint-disable-next-line eqeqeq
  if (level != null) {
    query.level = level
  }
  // eslint-disable-next-line eqeqeq
  if (week != null) {
    query.week = week
  }
  // eslint-disable-next-line eqeqeq
  if (permission != null) {
    query.permission = permission
  }
  if (langType) {
    query.langType = langType
  }
  if (sessionId) {
    query.sessionId = sessionId
  }
  if (referrer) {
    query.referrer = referrer
  }

  if (originals) {
    for (const [key, value] of Object.entries(originals)) {
      // eslint-disable-next-line eqeqeq
      if (value != null) {
        query[key] = value as string | number
      }
    }
  }

  return serializeUrl(`/lessons/classroom/${classId}`, { required: {}, optional: query })
}
